:host {
  width: fit-content;

  .addi-banner-wrapper {
    display: flex;
    width: fit-content;
    flex-direction: column;
    justify-content: flex-start;
  }

  .addi-banner-discount {
    display: flex;
    width: fit-content;
    padding: 2px 5px;
    background-color: $color-addi-comp-three-lighten2;
    border-radius: 5px 5px 0 0;
    color: $color-addi-font-primary;
  }

  .addi-banner {
    display: flex;
    border: 1px solid $color-addi-background-medium;
    width: fit-content;
    cursor: pointer;
    overflow: hidden;
    color: $color-addi-gray-darken3;

    &-bagde {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 8px;
    }
  }

  .addi-banner-bagde {
    &__icon {
      &--lineal {
        background: url('https://statics.addi.com/assets/addi-icon-lineal.png')
            no-repeat center,
          transparent;
        background-size: contain;
      }

      &--filled {
        background: url('https://statics.addi.com/assets/addi-icon.png')
            no-repeat center,
          transparent;
        background-size: contain;
      }
    }
  }

  .addi-banner-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    padding: 4px 8px 4px 4px;

    &__title {
      font-size: 1.1em;
      font-weight: $font-addi-weight-bold;
      padding: 0 0 5px;
      line-height: 1.3em;
    }

    &__message {
      font-weight: $font-addi-weight-regular;
      line-height: 1.4em;

      .loading {
        width: 250px;
      }

      &--strong {
        font-weight: $font-addi-weight-bold;
      }
    }

    &__addi-logo {
      height: 0.8em !important;
      display: inline-block;
      opacity: 1;
      transform: none;
      width: initial;
    }
  }

  .addi-banner-button {
    border: none;
    color: inherit;
    padding: 0;

    &__highlight {
      color: #000;
    }

    &--link {
      color: $color-addi-primary-active;
      background: none !important;
      width: auto !important;
      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      text-decoration: underline;
      cursor: pointer;
      outline: none;
    }
  }

  .loading {
    background-color: #ebebeb;
    background-image: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    background-size: 1000%;
    background-position: right;
    border-radius: 20px;
    width: 150px;
    height: 15px;
    animation: loading 1.5s ease-in-out infinite alternate;
    box-shadow: 0 0 6px 0 #e9e9e9b2;
  }

  @keyframes loading {
    0% {
      background-position: right;
    }
    100% {
      background-position: left;
    }
  }
}
